const Settings = () => import("@/modules/settings/pages/Settings.vue");
const Profile = () => import("@/modules/settings/pages/Profile.vue");
const Company = () => import("@/modules/settings/pages/Company.vue");
const Keys = () => import("../pages/Keys.vue");
import Team from "@/modules/team/routes/index";
import Webhooks from "@/modules/webhooks/routes/index";
import Automation from "@/modules/automation/routes/index";
import Subscriptions from "@/modules/subscriptions/routes/index";

export default [
  {
    path: "/settings",
    component: Settings,
    children: [
      {
        path: "",
        name: "profile",
        component: Profile,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/settings/company",
        name: "company",
        component: Company,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/settings/keys",
        name: "keys",
        component: Keys,
        meta: {
          authRequired: true,
          allowDevelopers: true,
        },
      },
      ...Team,
      ...Webhooks,
      ...Automation,
      ...Subscriptions,
    ],
    meta: {
      authRequired: true,
      isAdmin: true,
    },
  },
];
